import { Badge } from "@/components/ui/badge";

export function SourceBadge({ source }: { source: string }) {
  const variant =
    source === "actual" ? "default" : source === "estimate" ? "secondary" : "outline";
  return <Badge variant={variant}>{source}</Badge>;
}

export function Stat({
  label,
  value,
  sub,
  tone,
}: {
  label: string;
  value: string;
  sub?: string;
  tone?: "good" | "bad";
}) {
  const toneClass =
    tone === "good"
      ? "text-emerald-600 dark:text-emerald-400"
      : tone === "bad"
        ? "text-destructive"
        : "";
  return (
    <div>
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className={`font-serif text-2xl font-semibold ${toneClass}`}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
